import api from '../apis/constants';
import { RevenueStats, DailyRevenue } from '../types/revenueStats';
import { TopSellingResponse, TopSellingItem } from '../types/topSelling';

const revenueService = {
    /**
     * Get revenue statistics for different time periods
     * @returns Promise with revenue statistics data
     */
    getRevenueStats: async (branchId: string | undefined): Promise<RevenueStats> => {
        try {
            if (!branchId) {
                const response = await api.get<RevenueStats>(`/manager/revenue-stats`);
                return response.data;
            } else {
                const response = await api.get<RevenueStats>(`/manager/revenue-stats?branch_id=${branchId}`);
                return response.data;
            }
        } catch (error) {
            console.error('Error fetching revenue stats:', error);
            throw error;
        }
    },

    /**
     * Get daily revenue statistics
     * @returns Promise with daily revenue data array
     */
    getDailyRevenue: async (branchId: string | undefined): Promise<DailyRevenue[]> => {
        try {
            if (!branchId) {
                const response = await api.get<DailyRevenue[]>(`/manager/daily-revenue`);
                return response.data;
            } else {
                const response = await api.get<DailyRevenue[]>(`/manager/daily-revenue?branch_id=${branchId}`);
                return response.data;
            }
        } catch (error) {
            console.error('Error fetching daily revenue:', error);
            throw error;
        }
    },

    /**
     * Get top-selling products and box templates
     * @returns Promise with top-selling data
     */
    getTopSelling: async (): Promise<TopSellingItem[]> => {
        try {
            const response = await api.get<TopSellingResponse>('/manager/top-selling');

            // Combine products and boxTemplates and sort by totalRevenue
            const combinedItems = [
                ...response.data.products,
                ...response.data.boxTemplates
            ].sort((a, b) => b.totalRevenue - a.totalRevenue);

            return combinedItems;
        } catch (error) {
            console.error('Error fetching top-selling items:', error);
            throw error;
        }
    }
};

export default revenueService; 